import React, { ReactNode } from "react";
import { Card } from "react-bootstrap";
import style from "./metricaTextCard.module.css";

interface Props {
  text: string | number | ReactNode;
  title: string | number | ReactNode;
  variant?: "primary" | "danger" | "warning";
}

export const MetricaTextCard = ({
  text,
  title,
  variant = "primary",
}: Props) => {
  return (
    <Card className={`${style["metrica-card"]} ${style[variant]}`}>
      <p className={style["metrica-text"]}>{text}</p>
      <hr></hr>
      <p className={style["metrica-title"]}>{title}</p>
    </Card>
  );
};
